import type { AxiosInstance, AxiosRequestConfig } from 'axios';

import type { PagePaginatedResponse, PaginationParams } from '../types/pagination';
import { buildPaginationParams, normalizePageMeta } from '../types/pagination';

/**
 * Fetch a page/offset-paginated list for any table-backed endpoint.
 *
 * Builds the `cursor`/`limit`/`page` query params (omitting unset values) and
 * normalises the returned `meta` to numbers so page arithmetic is safe. Extra
 * query params (filters, sort, etc.) can be passed via `config.params` and are
 * merged with the pagination params.
 */
export async function fetchPaginatedList<T>(
  client: AxiosInstance,
  url: string,
  pagination?: PaginationParams,
  config?: AxiosRequestConfig,
): Promise<PagePaginatedResponse<T>> {
  const { data } = await client.get<PagePaginatedResponse<T>>(url, {
    ...config,
    params: { ...buildPaginationParams(pagination), ...config?.params },
  });
  return normalizePageMeta(data);
}
